import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'ApiAppOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-api-app-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 15h-6.5a2.5 2.5 0 1 1 0 -5h.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15 15v3.5a2.5 2.5 0 1 1 -5 0v-.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M13 9h5.5a2.5 2.5 0 1 1 0 5h-.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 12v-3m.042 -3.957a2.5 2.5 0 0 1 4.958 .457v.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 3l18 18"
    }, null), _createTextVNode(" ")]);
  }
};